import { Component, Input } from '@angular/core';

@Component({
  selector: 'dgs-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class DGSLoadingComponent {
  private _loading: boolean;

  get loading(): boolean {
    return this._loading;
  }

  @Input() set loading(loading: boolean) {
    this._loading = loading;
  }
}
